import React, { FC } from 'react';
import cn from 'classnames';

import { useResponsive } from 'src/hooks/responsive';

type Props = {
  className?: string;
};

const Background: FC<Props> = ({ className = '' }) => {
  const [isMobile] = useResponsive('SMALL_MOBILE');
  const backgroundDesktop =
    'https://makostorepdl-a.akamaihd.net/SHORT/TV/public/2023/n12_170823_kipur/n12_170823_kipur_3100.mp4';
  const backgroundMobile =
    'https://makostorepdl-a.akamaihd.net/SHORT/STORIES/public/2023/08/27/public_270823_hayalim/public_270823_hayalim_550.mp4';
  const backgroundVideoUrl = isMobile ? backgroundMobile : backgroundDesktop;

  return <video src={backgroundVideoUrl} muted loop autoPlay playsInline className={cn(className)} />;
};

export default Background;
